class MobileStickyMenu extends HTMLElement {
  constructor() {
    super();
    this.cartCount = this.querySelector('[data-cart-count]');
    
    // Listen for cart changes
    document.addEventListener('cart:updated', (event) => {
      this.updateCartCount(event.detail.cart.item_count);
    });
    
    // Listen for cart drawer open/close events
    document.addEventListener('cart:refresh', (event) => {
      this.onCartRefresh();
    });
    
    // Initial cart count update
    this.onCartRefresh();
  }
  
  onCartRefresh() {
    fetch(window.routes.cart_url + '?section_id=cart-icon-bubble')
      .then(response => response.text())
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const sourceCartCount = html.querySelector('cart-icon-bubble .cart-count-bubble');
        
        if (sourceCartCount) {
          const count = parseInt(sourceCartCount.textContent.trim(), 10);
          this.updateCartCount(count);
        } else {
          this.updateCartCount(0);
        }
      })
      .catch(error => {
        console.error('Error fetching cart count:', error);
      });
  }
  
  updateCartCount(count) {
    if (count > 0) {
      this.cartCount.textContent = count;
      this.cartCount.classList.add('active');
    } else {
      this.cartCount.textContent = '';
      this.cartCount.classList.remove('active');
    }
  }
}

customElements.define('mobile-sticky-menu', MobileStickyMenu);

// Update mobile menu active state based on current page
document.addEventListener('DOMContentLoaded', () => {
  const mobileStickyMenu = document.getElementById('mobileStickyMenu');
  if (!mobileStickyMenu) return;
  
  // Ensure the correct menu item is active based on current URL
  const currentPath = window.location.pathname;
  const menuItems = mobileStickyMenu.querySelectorAll('.mobile-sticky-menu__item');
  
  menuItems.forEach(item => {
    const itemLink = item.getAttribute('href');
    if (itemLink && (currentPath === itemLink || currentPath.startsWith(itemLink) && itemLink !== '/')) {
      item.classList.add('mobile-sticky-menu__item--active');
    } else {
      item.classList.remove('mobile-sticky-menu__item--active');
    }
  });
}); 